// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2nkci","left":"InfoRow_left__19YWS"};